import { ReactElement, useEffect } from 'react'
import { CompanyLeadTemplate } from '.'
import {
    CompanyActions,
    CompanyLeadState,
    Goal,
} from '@raskrask-dk/bookingflow-state-machine'
import { useBFSM, useBFSMState } from '../../contexts/bfsmContext'
import { useBFSMValue } from '../../services/hooks/useBFSMValues'

const CompanyLeadPage = (): ReactElement => {
    const [BFSM] = useBFSM()
    const currentState = useBFSMState()

    const [, setGoal] = useBFSMValue<
        CompanyLeadState,
        CompanyActions.SetGoal,
        'goal'
    >('goal', CompanyActions.SetGoal)

    useEffect(() => {
        if (currentState.type === 'COMPANY') {
            setGoal(new Goal(23, 'CompanyMassage'))
            BFSM.doAction(CompanyActions.SetCompanySettings, {})
        }
    }, [])

    const goToNextState = () => {
        BFSM.doAction(CompanyActions.Next, undefined)
    }

    const canGoNext = BFSM.canDo(CompanyActions.Next)

    return (
        <CompanyLeadTemplate
            canGoNext={canGoNext}
            goToNextState={goToNextState}
        />
    )
}

export default CompanyLeadPage
